import { Link } from 'react-router'
import { FontIcon } from 'material-ui'
import TextField from 'material-ui/TextField'
import DoneIcon from 'material-ui/svg-icons/action/done'

import { Button } from 'components'
import { AnalyticsUtils } from 'utils'

import './setupTemplates.scss'

export default class SetupTemplates extends React.Component {
  static propTypes = {
    initialValues:  React.PropTypes.object,
    title:          React.PropTypes.string.isRequired,
    checklist:      React.PropTypes.array.isRequired,
    variables:      React.PropTypes.array.isRequired,
    onSave:         React.PropTypes.func.isRequired,
    nextRoute:      React.PropTypes.string.isRequired,
    prevRoute:      React.PropTypes.string.isRequired,
  }

  static contextTypes = {
    currentUser: React.PropTypes.object
  }

  state = {
    variables: {},
  }

  setVariable(key, value) {
    this.setState({
      variables: {
        ...this.state.variables,
        [key]: value,
      },
    })
  }

  save = () => {
    const { currentUser: { email } } = this.context

    for (let variable of this.props.variables) {
      if (this.state.variables[variable.key]) {
        AnalyticsUtils.onboardingFieldCompleted(email, variable.key, this.state.variables[variable.key])
      }
    }
    AnalyticsUtils.onboardingStepCompleted(email)

    this.props.onSave(this.state.variables)
  }

  renderChecklist() {
    return (
      <div className="setupTemplates__checklist">
        {this.props.checklist.map((checkpoint, index) => (
          <div className="setupTemplates__checkpoint" key={`checkpoint-${index}`}>
            <DoneIcon color="#49A74C" />
            <span className="text small-spacing--left">{checkpoint}</span>
          </div>
        ))}
      </div>
    )
  }

  renderInputs() {
    return (
      <div className="setupTemplates__inputs">
        {this.props.variables.map((variable, index) => (
          <div className="setupTemplates__input medium-spacing--top" key={`input-${index}`}>
            <TextField
              placeholder={variable.placeholder}
              value={this.state.variables[variable.key] || ''}
              name={variable.key}
              fullWidth
              multiLine
              onChange={({ target: { value } }) => this.setVariable(variable.key, value) }
            />
            <div className="hint">{variable.hint}</div>
          </div>
        ))}
      </div>
    )
  }

  renderActions() {
    const isLastStep = this.props.prevRoute === '/setup/title'

    return (
      <div className="setupTemplates__actions xlarge-spacing--top">
        <Button
          label={isLastStep ? 'Save and Finish' : 'Save and Continue'}
          buttonType="primary"
          onTouchTap={this.save}
        />
        <Link to={this.props.nextRoute}>
          <Button
            label="Skip for now"
            buttonType="secondary"
            className="small-spacing--left"
            onTouchTap={() => AnalyticsUtils.onboardingStepSkipped(this.context.currentUser.email)}
          />
        </Link>
      </div>
    )
  }

  render() {
    return (
      <div className="setupTemplates">
        <Link to={this.props.prevRoute} className="setupTemplates__backLink">
          <FontIcon style={{ color: '#5750C5', fontSize: 18 }} className="material-icons">arrow_back</FontIcon>
          <span>Back</span>
        </Link>
        <div className="setupTemplates__title">
          <h2 className="large-spacing--bottom">{this.props.title}</h2>
        </div>
        {this.renderChecklist()}
        {this.renderInputs()}
        {this.renderActions()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/onboarding/SetupTemplates.js